import React from 'react'

import { Avatar, AvatarStatus, Icon } from '../../../../components/UI'
import MultiTalent from '../../../../components/Shared/MultiTalent'
import UpcomingClassLanguage from '../../../common/Statistic/UpcomingClassLanguage'

import { arrayFromNumber, getUserName } from '../../../../helpers'

import { imagePrefix } from '../../../../constants'

const TutorDetailsUser = ({ classBanner }) => {
  const userLanguagesContent = (classBanner.creator_profile?.languages || []).map((language) => {
    return (
      <UpcomingClassLanguage
        key={`lang-${typeof language === 'string' ? language : language.iso_639_1_code}`}
        language={language}
      />
    )
  })

  const starsContent = arrayFromNumber(8).map((star) => {
    return <Icon key={star} name="sun-check" className="w-[36px] h-[36px]" />
  })

  return (
    <div className="w-full mt-[10px] p-[20px] pb-[32px] rounded-[10px] border-[1px] border-[#FFCA84] bg-[#FFF5EE] flex items-center justify-center flex-col">
      <div className="w-full flex items-center justify-end">
        <Icon name="flag" color="#F79009" className="w-[24px] h-[24px]" />
      </div>

      <div className="mt-[10px] relative">
        <Avatar
          src={`${imagePrefix}${classBanner.class_banner_creator?.profile_picture}`}
          gender={classBanner.creator_profile?.gender}
          className="w-[124px] h-[124px]"
        />

        <AvatarStatus status="online" />
      </div>

      <div className="w-full flex items-center justify-center mt-[16px]">
        <h2 className="text-2xl font-bold text-primary-100 max-w-[80%]">
          {getUserName(
            classBanner.class_banner_creator,
            classBanner.creator_profile?.display_name,
            classBanner.creator_profile?.display_last_name
          )}
        </h2>

        <button className="ml-[10px]">
          <Icon name="heart" color="#EF4343" className="w-[36px] h-[36px]" />
        </button>
      </div>

      <div className="mt-[16px] w-full flex items-center justify-center">
        {true && <MultiTalent />}

        <div className="gap-x-[2px] flex items-center ml-[8px]">{starsContent}</div>
      </div>

      <div className="mt-[16px] w-full flex items-center justify-center gap-x-[16px]">
        <div className="flex justify-center items-center">
          <img
            className="w-[24px] h-[24px]"
            src="/assets/icon/checkbox-multiple-line.svg"
            alt="Check"
          />

          <span className="text-primary-100 font-normal ml-1 text-sm">
            {classBanner.tutor_stats?.total_bookings || 0}
          </span>
        </div>

        <div className="flex justify-center items-center">
          <img className="w-[24px] h-[24px]" src="/assets/icon/user-green.svg" alt="User" />

          <span className="text-primary-100 font-normal ml-1 text-sm">
            {classBanner.tutor_stats?.total_students || 0}
          </span>
        </div>

        <div className="flex justify-center items-center">
          <span className="text-[#B733DD] text-sm font-semibold">ROI</span>

          <span className="text-primary-100 font-normal ml-1 text-sm">
            {classBanner.tutor_stats?.roi || 0}%
          </span>
        </div>
      </div>

      <div className="mt-[10px] flex items-center justify-center w-full">
        <div className="flex items-center justify-center mr-[8px]">
          <div className="mr-[9px]">
            <img className="block" src="/assets/icon/fontOrangeIcon.png" alt="language" />
          </div>

          <ul className="flex items-center justify-center flex-wrap gap-[8px]">
            {userLanguagesContent}
          </ul>
        </div>

        <div className="flex items-center justify-center gap-x-[10px]">
          <div className="flex items-center justify-center">
            <Icon className="mr-[6px]" name="global-line" color="#F79009" />

            {/* TODO: make dynamic data */}
            <img className="block" src="/assets/image/America_Flag.svg" alt="us" />
          </div>

          <div className="flex items-center justify-center">
            <Icon className="mr-[6px]" name="home" color="#F79009" />

            {/* TODO: make dynamic data */}
            <img className="block" src="/assets/image/Canada_Flag.svg" alt="us" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TutorDetailsUser
